/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import {
  Boton,
  Titulo,
  Formulario,
  Sidebar,
  accessAPI,
  tituloBase,
  TablaFiltrable,
  usePermiso
} from "../../../../shared";

const SEARCH_FIELDS = ["nombre", "apellido", "email"];

export default function Administradores() {
  const [loader, setLoader] = useState(true);
  const [administradores, setAdministradores] = useState([]);
  const [sideBar, setSideBar] = useState(false);
  const [formLoader, setFormLoader] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();
  // Con lectura se ve el listado, sin poder dar de alta
  const { puedeEditar } = usePermiso("admin.administradores");

  function crearAdministrador(camposFormulario) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/administrador",
      camposFormulario,
      (respuesta) => {
        setFormLoader(false);
        setSideBar(false);
        navigate(`/config/administradores/${respuesta.id}`);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear el administrador",
          sticky: true
        });
      }
    );
  }

  const crearFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre",
            requerido: true
          },
          {
            nombre: "apellido",
            tipoitemformularioid: 1,
            etiqueta: "Apellido",
            requerido: true
          },
          {
            nombre: "email",
            tipoitemformularioid: 1,
            etiqueta: "Email",
            requerido: true
          },
          {
            nombre: "accesotipo",
            tipoitemformularioid: 5,
            etiqueta: "Rol",
            opciones: "admin/administrador/roles",
            requerido: true,
            // Sin rol preseleccionado: hay que elegirlo
            sinOpcionInicial: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Crear administrador",
        callback: crearAdministrador,
        validar: true
      }
    ]
  };

  function cargar() {
    accessAPI(
      "GET",
      "admin/administrador",
      null,
      (respuesta) => {
        setAdministradores(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar los administradores",
          sticky: true
        });
        setLoader(false);
      }
    );
  }

  useEffect(() => {
    document.title = "Administradores";
    cargar();
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Sidebar
        visible={sideBar}
        onHide={() => setSideBar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nuevo administrador</Titulo>
        <Formulario config={crearFormConfig} loader={formLoader} />
      </Sidebar>

      {loader && (
        <div
          css={{
            marginTop: "2em",
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem"
          }}
        >
          <Skeleton
            width="15rem"
            height="2.5rem"
            css={{ marginBottom: "0.5rem" }}
          />
          <Card>
            <div
              css={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem"
              }}
            >
              <Skeleton width="100%" height="3rem" />
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            urlVolver="/config"
            botones={
              puedeEditar && (
                <Boton callback={() => setSideBar(true)}>
                  Nuevo administrador
                </Boton>
              )
            }
          >
            Administradores
          </Titulo>

          <Card>
            <TablaFiltrable
              value={administradores}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="administradores"
              emptyMessage="No hay administradores registrados"
              onRowClick={(e) => {
                const uri = `/config/administradores/${e.data.id}`;
                if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
                  window.open(uri, "_blank");
                } else {
                  navigate(uri);
                }
              }}
              rows={10}
              css={{
                "& .p-datatable-tbody > tr": { cursor: "pointer" }
              }}
            >
              <Column
                header="Nombre"
                body={(a) => [a.nombre, a.apellido].filter(Boolean).join(" ")}
              />
              <Column header="Email" field="email" />
              <Column header="Rol" field="rol" />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
